export default {
  menuDiscountLabel: {
    color: '#CF1E91'
  },
  tagIcon: {
    transform: 'scaleX(-1)'
  }
};

